var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJsonpadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 64C63 25.7 92.7 0 128 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V64z",
    fill: "#222831",
    opacity: "undefined"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "141.65 297.38 867.19 534.14",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9360 7256c-399-72-817-277-1361-667-314-225-799-606-1004-790-428-383-866-921-1429-1759-178-264-273-385-421-538-229-237-456-376-695-428-99-21-292-18-404 6-155 34-370 115-467 176-108 67-257 261-340 440-194 420-219 904-67 1343 98 283 260 539 501 788l108 112-46 7c-98 14-312-21-474-78-221-77-441-226-589-397-221-258-359-597-414-1021-16-129-16-531 0-645 37-259 108-487 222-720 129-263 264-451 462-641 154-149 310-258 498-348 143-69 297-120 448-148 165-31 392-31 552 1 453 89 952 371 1412 797 151 140 267 275 377 441 107 160 186 318 326 653 131 313 229 515 338 691 294 478 840 1132 1472 1764 340 341 528 513 639 587 165 109 414 215 679 288 61 18 137 39 167 47l55 16-50 14c-71 21-396 26-495 9z",
    transform: "matrix(.1 0 0 -.1 0 1024)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3845 7249c-648-62-1286-363-1721-810-276-285-435-558-567-975-186-588-187-1229-5-1794 204-630 611-1117 1084-1295 36-14 73-25 81-25 9 0-9 28-42 67-152 181-274 362-363 539-296 591-343 1261-134 1924 49 155 68 203 131 327 162 324 404 576 691 722 140 71 298 123 445 146 149 24 478 16 605-13 171-40 283-89 425-186 185-126 355-318 454-514 104-207 152-407 152-639 0-516-303-1001-861-1379-55-37-100-71-100-75 0-8 61-22 141-34s221 19 334 74c134 64 245 148 395 300 196 197 352 401 705 916 396 578 742 960 1354 1495l314 275-274 6c-234 6-294 10-414 33-350 64-564 154-990 416-379 232-580 329-843 405-150 42-347 82-481 95-120 12-386 11-516-1zM10005 6667c-369-248-722-418-1035-499-141-37-169-41-315-45-88-3-184-1-213 5l-53 9-268-301c-405-457-582-666-742-881-77-103-109-150-109-160 0-18 274 50 435 107 503 180 1013 484 1505 898 174 146 543 515 696 695 125 147 188 225 182 225-2 0-39-24-83-53z",
    transform: "matrix(.1 0 0 -.1 0 1024)"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(-48.085 1.203) scale(1.48113)",
    x: 1.53,
    xlinkHref: "#a",
    y: 11.75
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.78713 0 0 .78713 11.197 -60.757)",
    x: 159.38,
    xlinkHref: "#b",
    y: 289.32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsonpadLogo);
export default __webpack_public_path__ + "static/media/jsonpad-logo.e78b1620a5f1d1e2767de8192821047b.svg";
export { ForwardRef as ReactComponent };